import styled from "styled-components";

const EmptyActionIcon = styled.div`
  width: 40px;
  height: 20px;
`;

export default EmptyActionIcon;
